import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { notificationPreferencesApiRef, NotificationPreferencesClient } from './api';

export const notificationPreferencesPlugin = createPlugin({
  id: 'notification-preferences',
  routes: { root: rootRouteRef },
  apis: [
    createApiFactory({
      api: notificationPreferencesApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new NotificationPreferencesClient(discoveryApi, fetchApi),
    }),
  ],
});

export const NotificationPreferencesPage = notificationPreferencesPlugin.provide(
  createRoutableExtension({
    name: 'NotificationPreferencesPage',
    component: () =>
      import('./components/NotificationPreferencesPage').then(m => m.NotificationPreferencesPage),
    mountPoint: rootRouteRef,
  }),
);
